import { tr } from "../../../../date-fns/locale/tr.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    tr
  }
};